module.exports = __webpack_public_path__ + "static/img/icon6.f3c98344.gif";